/* eslint-disable max-len */
import { RouteRecordRaw } from 'vue-router';

const UsefulLinksList = () =>
  import(
    /* webpackChunkName: "PublicUsefulLinksList" */ 'PortalDir/modules/UsefulLinks/pages/List.vue'
  );

const UsefulLinksView = () =>
  import(
    /* webpackChunkName: "PublicUsefulLinksView" */ 'PortalDir/modules/UsefulLinks/pages/UsefulLinksView.vue'
  );

const routes: Array<RouteRecordRaw> = [
  {
    path: '/useful-links/',
    name: 'useful-links',
    component: UsefulLinksList,
  },
  {
    path: '/useful-links/:usefulLinkId',
    name: 'useful-link-view',
    component: UsefulLinksView,
    props: true,
  },
];

export default routes;
